import router from 'src/router';

export async function openClientDetails(clientId: string, isReceived?: boolean): Promise<boolean> {
  await router.push({ name: 'client-details', params: { id: clientId } });
  return Promise.resolve(true);
}

export function openClientMiniature(clientId: string, isReceived?: boolean): void {
  router.push({ name: 'client-miniature', params: { id: clientId } });
}

export function openClientDetailsInNewTab(clientId: string, isReceived?: boolean): void {
  const url = router.resolve({ path: `/client-details/${clientId}` }).href;
  window.open(url, '_blank');
}

export function openClientMiniatureInNewTab(clientId: string, isReceived?: boolean): void {
  const url = router.resolve({ path: `/clients/${clientId}` }).href;
  window.open(url, '_blank');
}

export function openAccountInNewTab(id: string): void {
  const url = router.resolve({ path: `/accounts/${id}` }).href;
  window.open(url, '_blank');
}

export function getUser(id: string): void {
  router.push(`/accounts/${id}`).then();
}
